// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n#order-tree-detail-container {\n  width: 100%;\n  min-height: 100vh;\n  background-color: white;\n  display: flex;\n}\n#order-tree-detail-container #data-tree-container {\n  width: 25%;\n  background-color: rgb(240, 242, 245);\n}\n#order-tree-detail-container #selected-content {\n  width: 75%;\n  background-color: white;\n  position: relative;\n  max-height: 100vh;\n}\n#order-tree-detail-container #selected-content iframe {\n  width: 100%;\n  height: 100%;\n}\n.loading-container {\n  text-align: center;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n}\n.loading-container .el-icon-loading {\n  font-size: 3pc;\n}", ""]);
// Exports
exports.locals = {
	"menuBg": "#304156",
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF"
};
module.exports = exports;
